// store for the survey component
const state = () => ({
  survey: [], // all survey info
  sections: [], // all sections
  selectedAnswers: {}, // all user responses
  surveyResult: '', // Not implemented
  reportPath: '', // Not implemented
  CAE: [], // all CAE ids and descriptions to display in the frontend
  Municipality: [], // all municipality descriptions to display in the frontend
  surveyButtonPressed: localStorage.getItem('surveyButtonPressed') === 'true', // control with a combination of the state and localstorage if the user submited survey
});

const getters = {
  survey(state) {
    return state.survey;
  },
  CAE(state) {
    return state.CAE;
  },
  Municipality(state) {
    return state.Municipality;
  },
  sections(state) {
    return state.sections;
  },
  selectedAnswers(state) {
    return state.selectedAnswers;
  },
  surveyResult(state) {
    return state.surveyResult;
  },
  reportPath(state) {
    return state.reportPath;
  },
  isSurveyFinished(state) {
    return state.surveyResult !== '';
  },
};

const mutations = {
  setButtonPressed(state, value) {
    state.surveyButtonPressed = value;
    localStorage.setItem('surveyButtonPressed', value); // also store in the localStorage if the user pressed button
  },
  setSurvey(state, survey) {
    state.survey = survey;
  },
  setSections(state, sections) {
    state.sections = sections;
  },
  setSelectedAnswers(state, answers) {
    state.selectedAnswers = answers;
  },
  registerCAE(state, payload) {
    state.CAE = payload;
  },
  registerMunicipality(state, payload) {
    state.Municipality = payload;
  },
};

const actions = {
  // action to change the state of the button pressed
  setButtonPressed({ commit }, value) {
    commit('setButtonPressed', value);
  },

  // action to retrieve survey, CAE and Municipalities from backend and set them in the state
  async loadSurvey({ commit }) {
    try {
      // fetch the data from the backend (survey controller)
      const response = await fetch(process.env.VUE_APP_API_URL + '/survey');
      const responseData = await response.json();

      // Ensure the response data has the expected structure
      if (
        !responseData ||
        !responseData.questionnaire ||
        !responseData.sections ||
        !responseData.cae ||
        !responseData.municipalities ||
        !response.ok
      ) {
        throw new Error(responseData.error);
      }

      // get individual arrays for each data and commit to the state
      const survey = responseData.questionnaire;
      const sections = responseData.sections;
      const CAE = responseData.cae;
      const Municipality = responseData.municipalities;
      commit('setSurvey', survey);
      commit('setSections', sections);
      commit('registerCAE', CAE);
      commit('registerMunicipality', Municipality);
      return true;
    } catch (error) {
      return error;
    }
  },

  // send answers to the backend
  async registerAnswers({ state }, { currentYear, priorYear, Company_Id }) {
    try {
      const selectedAnswers = state.selectedAnswers;

      // Prepare the payload to be sent to the backend
      const payloadToSend = {
        Company_Id: Company_Id, // same id obtained when user register companied
        Answers: selectedAnswers, // survey answers
        CY: currentYear,
        PY: priorYear,
      };

      // send POST request with the payload
      const response = await fetch(process.env.VUE_APP_API_URL + '/survey', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payloadToSend),
      });

      // deal with errors
      if (!response.ok) {
        const errorMessage = await response.text();
        throw new Error(errorMessage || 'Erro ao register as respostas');
      }
      return true;
    } catch (error) {
      return error.message;
    }
  },

  // to download excel templates for the user to fill in certain questions
  async downloadTemplate() {
    // Fetch the files directly
    const response = await fetch(
      process.env.VUE_APP_API_URL + '/survey/download',
      {
        method: 'GET',
        responseType: 'blob', // Set the response type to blob since its a file
      }
    );
    // Check if the response is successful
    if (!response.ok) {
      throw new Error('Erro ao fazer download do ficheiro');
    }
    // Create a blob from the response
    const blob = await response.blob();
    return blob;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};